export { default } from "./CurricUnitCard";
